import { render, staticRenderFns } from "./display-field-birthdate.vue?vue&type=template&id=bdbd6aae&scoped=true&"
import script from "./display-field-birthdate.vue?vue&type=script&lang=ts&"
export * from "./display-field-birthdate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdbd6aae",
  null
  
)

export default component.exports